import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { makeUsersColumns } from "src/business/user/makeUsersColumns";
import { makeSidLabelsFromKeys, optionsMaker } from "src/common/optionsMaker";
import { MdmDrawer } from "src/components/MdmDrawer";
import { MdmTable, MdmTableSystemTools } from "src/components/MdmTable";
import { RtSearch } from "src/components/ReactiveTable/components/RtSearch";
import { RtSelection } from "src/components/ReactiveTable/components/RtSelection";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { UserFilters, ZSidLabel, ZUser } from "src/types";

type PropsSelectUserModal = {
  tableStore?: RtStore<ZUser, UserFilters>;
  srcSelected: ZSidLabel[];
  close: () => void;
  onApply: (values: ZSidLabel[]) => void;
};

export const SelectUserModal: React.FC<PropsSelectUserModal> = observer(
  (props) => {
    const { close, tableStore, srcSelected, onApply } = props;
    const columns = React.useMemo(() => makeUsersColumns(), []);
    const makeOption = React.useMemo(
      () => optionsMaker<ZUser>(srcSelected, ({ login }) => login),
      [srcSelected],
    );
    if (!tableStore) return null;
    const multiple = tableStore.selectionType === "checkbox";
    return (
      <MdmDrawer
        title={multiple ? "Выбор пользователей" : "Выбор пользователя"}
        open={!!tableStore}
        onClose={close}
        wide
        extra={
          <Button
            type="primary"
            disabled={tableStore.selectedKeys.length === 0}
            onClick={() => {
              onApply(
                makeSidLabelsFromKeys(tableStore.selectedKeys, makeOption),
              );
              close();
            }}
          >
            Выбрать
          </Button>
        }
      >
        <ToolBox2
          mainTool={<RtSelection store={tableStore} makeOption={makeOption} />}
        >
          <ToolBox2
            mainTool={<RtSearch store={tableStore} />}
            extraTools={<MdmTableSystemTools store={tableStore} />}
          >
            <MdmTable store={tableStore} columns={columns} />
          </ToolBox2>
        </ToolBox2>
      </MdmDrawer>
    );
  },
);
